// @flow
import type { Saga } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "../../actions/index";

export const createSagas = (API: Object): Object => {

	function* fetchPlayerNewsSaga(): Saga<void> {
		const result = yield call(API.player_news);
		yield put(actions.fetchPlayerNewsSuccess(result));
	}

	function* watch() {
		yield takeLatest(actions.fetchPlayerNews, fetchPlayerNewsSaga);
	}

	return {
		fetchPlayerNewsSaga,
		watch
	};
};

export default createSagas;